/**
 * A browser copy of `zCodePrefix` (`@miraki/contracts`), which cannot be
 * value-imported here (see `api/hooks.ts`). It only decides whether "Create N"
 * is offered on a new product; the server still validates. `code-prefix.spec.ts`
 * runs both against the same inputs, so the copy cannot drift silently.
 */
export const CODE_PREFIX_PATTERN = /^[A-Z0-9]+(-[A-Z0-9]+)*$/;
export const CODE_PREFIX_MIN = 2;
export const CODE_PREFIX_MAX = 24;

export const isCodePrefix = (s: string): boolean =>
  s.length >= CODE_PREFIX_MIN && s.length <= CODE_PREFIX_MAX && CODE_PREFIX_PATTERN.test(s);
